import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { globalModalsSelector } from 'selectors/page/headerFooterTemplate/data/globalModals/globalModalsSelector';
import AutoReplenishmentActions from 'actions/AutoReplenishmentActions';
import { globalModals, renderModal } from 'utils/globalModals';

const { AUTO_REPLENISH_FAQS } = globalModals;

/**
 * Provides modal openers for the AutoReplenishment hub.
 */
export function useModals() {
    const modalRegistry = useSelector(globalModalsSelector);
    const dispatch = useDispatch();

    const openFAQModal = useCallback(
        () => renderModal(modalRegistry[AUTO_REPLENISH_FAQS], () => dispatch(AutoReplenishmentActions.openFAQModal())),
        [modalRegistry, dispatch]
    );

    return { openFAQModal };
}
